export default __webpack_public_path__ + "static/media/min-vehicle.5e8c6923.svg";